import type { TFunction } from 'i18next';

/**
 * The words for the WhatsApp connection status, keyed on the status text the
 * ladder in ConnectedEnginesSlice emits. One copy, shared by the header chip and
 * the AI chat menu (btgpt), so both always say the same thing.
 */

/** The short status label ("WhatsApp Web Only"). */
export function engineStatusLabel(t: TFunction, statusText: string): string {
  const statusMap: Record<string, string> = {
    'Not Connected': t('status.notConnected'),
    'WhatsApp Ready (Offline OK)': t('status.whatsAppReadyOfflineOk'),
    'Scan QR Code to Connect': t('status.scanQrCodeToConnect'),
    'WhatsApp Gateway Starting...': t('status.whatsAppGatewayStarting'),
    'WhatsApp Web Only': t('status.whatsAppWebOnly'),
    'No WhatsApp Connected': t('status.noWhatsAppConnected'),
    'WhatsApp Logged Out': t('status.whatsAppLoggedOut', 'WhatsApp logged out, scan the QR'),
  };
  return statusMap[statusText] || statusText;
}

/** What that state MEANS, in one plain sentence. */
export function engineStatusHint(t: TFunction, statusText: string): string | undefined {
  const hintMap: Record<string, string> = {
    'Not Connected': t(
      'status.hint.engine.notConnected',
      "We've lost the connection to the Blueticks server, so messages may not be delivered until it reconnects."
    ),
    'WhatsApp Ready (Offline OK)': t(
      'status.hint.engine.ready',
      'Your WhatsApp Gateway is connected. Messages are sent even when your computer is off.'
    ),
    'Scan QR Code to Connect': t(
      'status.hint.engine.scanQr',
      'Your Gateway is ready. Scan the QR code with WhatsApp on your phone to finish connecting.'
    ),
    'WhatsApp Gateway Starting...': t('status.hint.engine.starting', 'Your WhatsApp Gateway is starting up. This usually takes a moment.'),
    'WhatsApp Web Only': t(
      'status.hint.engine.webOnly',
      'Messages are sent only while WhatsApp Web is open in your browser. Add a Gateway to keep sending when your computer is off.'
    ),
    'No WhatsApp Connected': t('status.hint.engine.noWhatsApp', "No WhatsApp is connected, so messages can't be sent."),
    'WhatsApp Logged Out': t(
      'status.hint.engine.loggedOut',
      "WhatsApp Web is logged out, so messages can't be sent. Open WhatsApp Web and scan the QR code to link it again."
    ),
  };
  return hintMap[statusText];
}
